export default __webpack_public_path__ + "static/media/2012.2311f1c8.png";